import { runtimeEnv } from '@/config/featureFlags';

export const SENSITIVE_PARAM_KEYS = Object.freeze([
  'token',
  'access_token',
  'refresh_token',
  'password',
  'email',
  'raw_url',
  'image_url',
  'payment_secret',
  'api_secret',
  'prompt'
]);

function isSensitiveKey(key) {
  const lowerKey = String(key).toLowerCase();
  return SENSITIVE_PARAM_KEYS.some((sensitive) => lowerKey === sensitive);
}

export function sanitizeAnalyticsParams(params = {}) {
  const cleaned = {};

  for (const [key, value] of Object.entries(params)) {
    if (isSensitiveKey(key)) {
      if (runtimeEnv.isDevelopment) {
        console.warn(`[Analytics] Sensitive param dropped: ${key}`);
      }
      continue;
    }
    cleaned[key] = value;
  }

  return cleaned;
}
